// This will help locate the ellipses menu for calendar
export const CALENDAR_ELLIPSES_ID = 'calendar_ellipses_menu';
